module.exports = __webpack_public_path__ + "static/media/organic.c77a82b5.svg";